import { render, staticRenderFns } from "./jingxuan.vue?vue&type=template&id=aff31f82&scoped=true&"
import script from "./jingxuan.vue?vue&type=script&lang=js&"
export * from "./jingxuan.vue?vue&type=script&lang=js&"
import style0 from "./jingxuan.vue?vue&type=style&index=0&id=aff31f82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff31f82",
  null
  
)

export default component.exports